// Journal templates data
// NOTE: The source of truth is journalTemplates.json
// This TypeScript file mirrors that JSON structure for type-safe imports
// If you update the JSON, please update this file to match

export const journalTemplatesData = {
  journalTemplates: [
    {
      id: "nature",
      label: "Nature",
      publisher: "Springer Nature",
      sizePolicy: {
        mode: "columns",
        widths_mm: [89.0, 183.0],
        maxHeight_mm: 247.0,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1200,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 5,
        fontSizePt_max: 7,
        fontSizePt_range: [5, 7],
        panelLabelPt: 8,
        lineWeightPt_min: 0.25,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.25, 1.0],
      },
      colorPolicy: {
        mode: "CMYK_or_RGB",
        notes: "Colour images supplied in RGB (recommended) and converted to CMYK for print[1].",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://www.nature.com/nature/for-authors/final-submission",
          title: "Nature: Final submission guidelines",
          lastChecked: "2025-11-09",
        },
        {
          url: "https://www.nature.com/nature/for-authors/figure-specifications",
          title: "Nature figure specifications",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Standard widths: 89 mm (single column) and 183 mm (double) with page depth 247 mm[2]; fonts: Helvetica/Arial 5–7 pt (except panel labels 8 pt)[3]; line weights 0.25–1 pt[2].",
    },
    {
      id: "science",
      label: "Science",
      publisher: "AAAS",
      sizePolicy: {
        mode: "columns",
        widths_mm: [89.0, 185.4],
        maxHeight_mm: null,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1200,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 5,
        fontSizePt_max: 8,
        fontSizePt_range: [5, 8],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "CMYK_or_RGB",
        notes: "Authors may supply figures in RGB; figures are printed in CMYK (RGB recommended).",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "",
          title: "",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Unable to locate a definitive source. Figures typically fit 1 col (~89 mm) or 2 col (~184 mm)[4]. Text labels often Helvetica, ~5–8 pt; line weight ~0.3–1 pt. Figures should be 300 dpi (color/gray) or higher (500–1200 dpi for line art).",
    },
    {
      id: "science_advances",
      label: "Science Advances",
      publisher: "AAAS",
      sizePolicy: {
        mode: "columns",
        widths_mm: [88.9, 185.4],
        maxHeight_mm: null,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1200,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 5,
        fontSizePt_max: 8,
        fontSizePt_range: [5, 8],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "RGB",
        notes: "All color figures must be supplied in RGB format.",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "",
          title: "",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Guidelines not found; assumed same as Science (AAAS)[4].",
    },
    {
      id: "cell",
      label: "Cell",
      publisher: "Cell Press",
      sizePolicy: {
        mode: "columns",
        widths_mm: [85.0, 174.0],
        maxHeight_mm: null,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1200,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 6,
        fontSizePt_max: 8,
        fontSizePt_range: [6, 8],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.5,
        lineWeightPt_range: [0.5, 1.5],
      },
      colorPolicy: {
        mode: "RGB_or_CMYK",
        notes: "Authors can submit in RGB; final print in CMYK.",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "",
          title: "",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Column widths ~85 mm (1-col) and 174 mm (2-col)[5]. Font ~6–8 pt (Helvetica/Arial); line weight 0.5–1.5 pt.",
    },
    {
      id: "pnas",
      label: "PNAS",
      publisher: "National Academy of Sciences",
      sizePolicy: {
        mode: "columns",
        widths_mm: [87.0, 178.0],
        maxHeight_mm: 225.0,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 600,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 6,
        fontSizePt_max: 12,
        fontSizePt_range: [6, 12],
        panelLabelPt: 8,
        lineWeightPt_min: 0.28,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.28, 1.0],
      },
      colorPolicy: {
        mode: "RGB",
        notes: "Use RGB color mode; PNAS converts as needed.",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS"],
        alsoAccepted: ["PDF"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://www.pnas.org/author-center",
          title: "PNAS Submissions Guidelines",
          lastChecked: "2025-11-09",
        },
        {
          url: "https://academic.oup.com/pnasnexus/pages/general-instructions",
          title: "PNAS Nexus: Author Instructions",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Figure width 1-col ~87 mm[6]. Text 6–12 pt; lines ≥0.28 pt[7]. Color images: RGB only[6]. Resolutions: ≥350 dpi for photos, ≥600 dpi for line art[8].",
    },
    {
      id: "acs_generic",
      label: "ACS Journals",
      publisher: "American Chemical Society",
      sizePolicy: {
        mode: "columns",
        widths_mm: [84.7, 177.8],
        maxHeight_mm: 233.0,
      },
      dpiPolicy: {
        lineArt: 1200,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1200,
      },
      typography: {
        fontFamily: ["Helvetica", "Arial"],
        fontSizePt_min: 4.5,
        fontSizePt_max: 12,
        fontSizePt_range: [4.5, 12],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "RGB_or_CMYK",
        notes: "Color reproduction is provided at no cost[9].",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://researcher-resources.acs.org/publish/author_guidelines?coden=jacsat",
          title: "ACS Author Guidelines",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Min dpi: 1200 (line art), 600 (grayscale), 300 (color)[10]. Single-col width 84.7 mm; max depth 233 mm[11]; lettering ≥4.5 pt; lines ≥0.5 pt[12].",
    },
    {
      id: "plos_generic",
      label: "PLOS Journals",
      publisher: "Public Library of Science",
      sizePolicy: {
        mode: "columns",
        widths_mm: [66.8, 190.5],
        maxHeight_mm: 223.0,
      },
      dpiPolicy: {
        lineArt: 600,
        halftone: 300,
        combination: 600,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 600,
      },
      typography: {
        fontFamily: ["Arial", "Times"],
        fontSizePt_min: 8,
        fontSizePt_max: 12,
        fontSizePt_range: [8, 12],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "RGB_or_Grayscale",
        notes: "Figures should be supplied in RGB (8-bit) or grayscale[13].",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS"],
        alsoAccepted: [],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://journals.plos.org/plosone/s/figures",
          title: "PLOS ONE Figure Preparation Guidelines",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Figure DPI: 300–600 dpi; only TIFF/EPS allowed[14]. Font: Arial/Times 8–12 pt[15]. Color mode: RGB or grayscale[13].",
    },
    {
      id: "elsevier_generic",
      label: "Elsevier Journals",
      publisher: "Elsevier",
      sizePolicy: {
        mode: "columns",
        widths_mm: [90.0, 190.0],
        maxHeight_mm: 225.0,
      },
      dpiPolicy: {
        lineArt: 1000,
        halftone: 300,
        combination: 500,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 1000,
      },
      typography: {
        fontFamily: ["Arial", "Helvetica", "Times New Roman", "Courier", "Symbol"],
        fontSizePt_min: 6,
        fontSizePt_max: 10,
        fontSizePt_range: [6, 10],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "CMYK_or_RGB",
        notes: "Submit color images in original RGB; Elsevier converts to CMYK for print.",
      },
      fileFormats: {
        preferred: ["EPS", "PDF", "TIFF", "JPEG"],
        alsoAccepted: ["DOCX", "PPTX"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://www.elsevier.com/about/policies-and-standards/author/artwork-and-media-instructions/artwork-sizing",
          title: "Elsevier Artwork Sizing (author guidelines)",
          lastChecked: "2025-11-09",
        },
        {
          url: "https://www.elsevier.com/about/policies-and-standards/author/artwork-and-media-instructions/artwork-overview",
          title: "Elsevier Artwork Overview",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Text ~7 pt (min 6 pt)[16]. DPI: 300 (photos), 1000 (line art)[17]. Preferred formats: EPS, PDF, TIFF, JPEG[18].",
    },
    {
      id: "wiley_generic",
      label: "Wiley Journals",
      publisher: "Wiley",
      sizePolicy: {
        mode: "columns",
        widths_mm: [85.0, 178.0],
        maxHeight_mm: null,
      },
      dpiPolicy: {
        lineArt: 600,
        halftone: 300,
        combination: null,
        final: null,
        raster_min: 300,
        raster_recommended_lineart: 600,
      },
      typography: {
        fontFamily: ["Arial", "Helvetica"],
        fontSizePt_min: 6,
        fontSizePt_max: 8,
        fontSizePt_range: [6, 8],
        panelLabelPt: 8,
        lineWeightPt_min: 0.5,
        lineWeightPt_max: 1.0,
        lineWeightPt_range: [0.5, 1.0],
      },
      colorPolicy: {
        mode: "CMYK_or_RGB",
        notes: "Preferred color mode is CMYK for print; RGB also accepted.",
      },
      fileFormats: {
        preferred: ["TIFF", "EPS", "PDF"],
        alsoAccepted: ["JPEG", "PNG"],
        vectorPreferred: true,
      },
      sources: [
        {
          url: "https://authorservices.wiley.com/prepare/graphical_abstract.html",
          title: "Wiley Graphics Guidelines (author services)",
          lastChecked: "2025-11-09",
        },
      ],
      notes: "Line art 600 dpi; halftones 300 dpi[19]. Ensure fonts are legible (~6–8 pt). Supply color in CMYK or RGB.",
    },
  ],
} as const;

